<script lang="ts">
  import type { Snippet } from "svelte";

  let {
    legend,
    note,
    error,
    class: className,
    legendClass,
    style,
    disabled = undefined,
    fieldset = $bindable<HTMLFieldSetElement>(),
    children,
    postfix = undefined
  } : {
    legend?: string | Snippet;
    note?: string;
    error?: string;
    class?: string;
    legendClass?: string;
    style?: string;
    disabled?: boolean;
    fieldset? : HTMLFieldSetElement;
    children: Snippet;
    postfix?: Snippet;
  } = $props()
</script>
<fieldset class="ui-fieldset {className}" {disabled} bind:this={fieldset} {style}>
  {#if legend}
    <legend class={legendClass}>
      {#if typeof legend === "function"}{@render legend()}{:else}{legend}{/if}
    </legend>
  {/if}
  {@render children?.()}
  {#if error}
    <p class="text-error">{error}</p>
  {:else if note}
    <p class="opacity-60">{note}</p>
  {/if}
  {@render postfix?.()}
</fieldset>
